import { render } from "./PondListItem.vue?vue&type=template&id=13b8710c&scoped=true&ts=true"
import script from "./PondListItem.vue?vue&type=script&lang=ts"
export * from "./PondListItem.vue?vue&type=script&lang=ts"

import "./PondListItem.vue?vue&type=style&index=0&id=13b8710c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b8710c"]])

export default __exports__